<template>
    <div v-if="!success && (!product.in_stock || soldOutVariations)">
        <div
            v-if="!product.in_stock"
            class="mb-3"
        >
            Enter your email address below to be notified when this product is available.
        </div>
        <div
            v-else
            class="mb-5"
        >
            <p class="text-sm my-5">
                Which items would you like to be notified about?
            </p>
            <CheckboxList
                v-model="selectedVariations"
                :items="soldOutVariations"
            />
        </div>

        <div class="flex">
            <TextInput
                v-model="email"
                :invalid="$v.email.$error"
                label=""
                placeholder="Email address"
                autocomplete="email"
                @enter="createStockNotification"
            >
                <template #errors>
                    <div v-if="!$v.email.required && $v.email.$dirty">
                        Please enter your email address.
                    </div>
                    <div v-if="!$v.email.email && $v.email.$dirty">
                        Please enter a valid email address.
                    </div>
                </template>
            </TextInput>

            <Button
                :loading="isLoading"
                class="ml-3"
                text="Go"
                @click="createStockNotification"
            />
        </div>
    </div>

    <p
        v-else
        class="flex"
    >
        <CheckIcon class="h-10 text-green-light mr-8 mt-1" />
        <span>Thank you! We'll email you when this product is available.</span>
    </p>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import TextInput from './Input';
import CheckboxList from './CheckboxList';
import Button from './Button';
import CheckIcon from '~/static/fonts/LineIcons/checkmark-circle.svg';

export default {
    components: {
        Button,
        CheckIcon,
        TextInput,
        CheckboxList,
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            email: '',
            isLoading: false,
            success: false,
            selectedVariations: [],
        };
    },
    computed: {
        soldOutVariations() {
            const variations = [];
            this.product.variation_types.forEach((type) => {
                type.variations.forEach((variation) => {
                    if (!variation.is_in_stock) {
                        variations.push({
                            value: variation.id,
                            label: `${type.name}: ${variation.name}`,
                        });
                    }
                });
            });

            return variations;
        },
    },
    methods: {
        createStockNotification() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.isLoading = true;

            this.$axios.post('stock-notifications', { product_id: this.product.id, email: this.email, variations: this.selectedVariations })
                .then((response) => {
                    this.isLoading = false;
                    this.success = true;
                })
                .catch((error) => {
                    this.isLoading = false;
                });
        },
    },
    validations: {
        email: {
            required,
            email,
        },
    },
};
</script>

<style scoped>

</style>
